<div class="search-list-container">
  <!-- Search Input -->
  <mat-form-field class="search-input" floatLabel="never" appearance="outline">
    <input
      matInput
      [placeholder]="searchPlaceholder"
      [formControl]="searchControl"
      [formlyAttributes]="field"
      autocomplete="off"
    />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <!-- Loading State -->
  <div *ngIf="isLoading$ | async" class="loading-container">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  </div>

  <!-- Results List -->
  <div class="options-container" [style.max-height]="maxHeight">
    <ng-container *ngIf="options$ | async as options">
      <ng-container *ngIf="options.length > 0; else noResults">
        <mat-list class="options-list">
          <mat-list-item 
            *ngFor="let option of options; trackBy: trackOption"
            class="option-item"
            (click)="onSelectionChange(option)"
            [class.selected]="isSelected(option)"
          >
            <!-- Option Content -->
            <div class="option-content">
              <div class="option-primary">{{ getOptionLabel(option) }}</div>
              <div 
                *ngIf="getOptionOrganizationType(option)" 
                class="option-type"
              >
                {{ getOptionOrganizationType(option) }}
              </div>
            </div>
            
            <!-- Distance Badge -->
            <div *ngIf="getOptionDistance(option) !== null" class="distance-badge">
              {{ getOptionDistance(option) }} mi
            </div>
          </mat-list-item>
        </mat-list>
      </ng-container>

      <!-- No Results Template -->
      <ng-template #noResults>
        <div *ngIf="(isLoading$ | async) === false" class="no-results">
          <mat-icon class="no-results-icon">search_off</mat-icon>
          <p class="no-results-text">{{ noResultsText }}</p>
        </div>
      </ng-template>
    </ng-container>

    <!-- Error State -->
    <div *ngIf="hasError$ | async" class="error-container">
      <mat-icon class="error-icon" color="warn">error</mat-icon>
      <p class="error-text">{{ 'common.errorLoadingResults' | t }}</p>
    </div>
  </div>
</div>
